import { CONSTANTS } from "client/utils/constants";
import { isEmail } from "utils";
const choices = [CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED,
    CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED,
    CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY,
    CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_IRON_PLANET,
    CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY,
    CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_IRON_PLANET,
    CONSTANTS.DISPOSITION_CHOICES.LEASE_RETURN,
    CONSTANTS.DISPOSITION_CHOICES.JJ_KANE_EQUIPMENT_AUCTION,
    undefined, null, ""]

const ValidateAssetLocationName = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationName === undefined || assetLocationDetails?.assetLocationName === "" || assetLocationDetails?.assetLocationName === null) {
        error.assetLocationNameError = "Please provide location name";
    } else if (assetLocationDetails?.assetLocationName?.length > 50) {
        error.assetLocationNameError = "Please enter Location Name less than 50 characters";
    } else {
        error.assetLocationNameError = "";
    }
    return error;
}

const ValidateName = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationContactName === undefined || assetLocationDetails?.assetLocationContactName === "" || assetLocationDetails?.assetLocationContactName === null) {
        error.assetLocationContactNameError = "Please provide contact name";
    } else if (assetLocationDetails?.assetLocationContactName?.length > 50) {
        error.assetLocationContactNameError = "Please enter Contact Name less than 50 characters";
    } else {
        error.assetLocationContactNameError = "";
    }
    return error;
}

const ValidateEmailAddress = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationEmail === undefined || assetLocationDetails?.assetLocationEmail === "" || assetLocationDetails?.assetLocationEmail === null || isEmail(assetLocationDetails?.assetLocationEmail)) {
        error.assetLocationEmailError = "Please enter valid email address";
    } else if (assetLocationDetails?.assetLocationEmail?.length > 50) {
        error.assetLocationEmailError = "Please enter Email Address less than 50 characters";
    } else {
        error.assetLocationEmailError = "";
    }
    return error;
}

const ValidatePhone = (assetLocationDetails: any, error: any) => {
    let phoneVal = assetLocationDetails?.assetLocationContactPhone?.match(/\d/g);
    if (phoneVal === "" || phoneVal === undefined || phoneVal === null || phoneVal?.length != 10 || phoneVal?.toString().trim()?.length == 0) {
        error.assetLocationContactPhoneError = "Please enter valid phone";
    } else {
        error.assetLocationContactPhoneError = "";
    }
    return error;
}

const ValidateAddress1 = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationAddress1 === undefined || assetLocationDetails?.assetLocationAddress1 === "" || assetLocationDetails?.assetLocationAddress1 === null) {
        error.assetLocationAddress1Error = "Please enter address 1";
    } else if (assetLocationDetails?.assetLocationAddress1?.length > 50) {
        error.assetLocationAddress1Error = "Please enter Address 1 less than 50 characters";
    } else {
        error.assetLocationAddress1Error = "";
    }
    return error;
}
const ValidateAddress2 = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationAddress2?.length > 50) {
        error.assetLocationAddress2Error = "Please enter Address 2 less than 50 characters";
    } else {
        error.assetLocationAddress2Error = "";
    }
    return error;
}

const ValidateCity = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationCity === undefined || assetLocationDetails?.assetLocationCity === "" || assetLocationDetails?.assetLocationCity === null) {
        error.assetLocationCityError = "Please enter city";
    } else if (assetLocationDetails?.assetLocationCity?.length > 100) {
        error.assetLocationCityError = "Please enter City less than 100 characters.";
    } else {
        error.assetLocationCityError = "";
    }
    return error;
}
const ValidateState = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationState === undefined || assetLocationDetails?.assetLocationState === "" || assetLocationDetails?.assetLocationState === null) {
        error.assetLocationStateError = "Please enter state";
    } else if (assetLocationDetails?.assetLocationState?.length > 2) {
        error.assetLocationStateError = "Please enter State less than 2 characters.";
    } else {
        error.assetLocationStateError = "";
    }
    return error;
}
const ValidateZip = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetLocationZip === undefined || assetLocationDetails?.assetLocationZip === 0 || assetLocationDetails?.assetLocationZip === null || assetLocationDetails?.assetLocationZip.toString() === "") {
        error.assetLocationZipError = "Please enter zip";
    } else if (assetLocationDetails?.assetLocationZip.toString().length > 10) {
        error.assetLocationZipError = "Please enter Zip less than 10 digits.";
    } else {
        error.assetLocationZipError = "";
    }
    return error;
}

const ValidateDispositionChoice = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetDispositionChoice === undefined || assetLocationDetails?.assetDispositionChoice === "" || assetLocationDetails?.assetDispositionChoice === null) {
        error.assetDispositionChoiceError = "Please select disposition choice";
    } else {
        error.assetDispositionChoiceError = "";
    }
    return error;
}

const ValidateProcessType = (assetLocationDetails: any, error: any) => {
    if (choices.includes(assetLocationDetails?.assetDispositionChoice)) {
        if (assetLocationDetails?.assetDispositionProcessType === undefined || assetLocationDetails?.assetDispositionProcessType === "" || assetLocationDetails?.assetDispositionProcessType === null) {
            error.assetDispositionProcessTypeError = "Please enter process type";
        } else {
            error.assetDispositionProcessTypeError = "";
        }
    } else {
        error.assetDispositionProcessTypeError = "";
    }

    return error;
}

const ValidateDispositionReasonCode = (assetLocationDetails: any, error: any) => {
    if (assetLocationDetails?.assetDispositionReasonCode === undefined || assetLocationDetails?.assetDispositionReasonCode === "" || assetLocationDetails?.assetDispositionReasonCode === null) {
        error.assetDispositionReasonCodeError = "Please select reason code";
    } else {
        error.assetDispositionReasonCodeError = "";
    }
    return error;
}

const ValidateReplacementFleetAssetOrder = (value: any, error: any) => {
    if (value !== undefined || value !== "" || value !== null) {
        if (value?.length > 16) {
            error.assetReplacementFleetAssetOrderError = "Please enter replacement fleet asset order less than 16 characters";
        } else {
            error.assetReplacementFleetAssetOrderError = "";
        }
    }
    return error;
}

const ValidateReplacementFleetAsset = (value: any, error: any) => {
    if (value !== undefined || value !== "" || value !== null) {
        if (value?.length > 16) {
            error.assetReplacementFleetAssetError = "Please enter replacement fleet asset less than 16 characters";
        } else {
            error.assetReplacementFleetAssetError = "";
        }
    }
    return error;
}

const ValidateLinkAttachments = (assetDetails: any, error: any) => {
    if (!choices.includes(assetDetails?.assetDispositionChoice)) {
        if (error.attachments.length <= 0) {
            error.isAttachmentsRequired = true
        } else {
            error.isAttachmentsRequired = false
        }
    } else {
        error.isAttachmentsRequired = false
    }
    return error;
}

const ValidatePenaltyExemptionReason = (isWriteOffPenaltyExemption: any, value: any, error: any) => {
    if (isWriteOffPenaltyExemption) {
        if (value?.length > 500) {
            error.assetDispositionPenaltyExemptionReasonError = "Please enter penalty exemption reason less than 500 characters";
        } else if (value?.toString()?.trim()?.length == 0 || value == null || value == undefined) {
            error.assetDispositionPenaltyExemptionReasonError = "Please enter penalty exemption reason.";
        } else {
            error.assetDispositionPenaltyExemptionReasonError = "";
        }
    } else {
        error.assetDispositionPenaltyExemptionReasonError = "";
    }
    return error;
}


export default {
    ValidatePenaltyExemptionReason,
    ValidateAssetLocationName,
    ValidateName,
    ValidatePhone,
    ValidateEmailAddress,
    ValidateAddress1,
    ValidateCity,
    ValidateState,
    ValidateZip,
    ValidateAddress2,
    ValidateDispositionChoice,
    ValidateProcessType,
    ValidateDispositionReasonCode,
    ValidateLinkAttachments,
    ValidateReplacementFleetAssetOrder,
    ValidateReplacementFleetAsset,
    choices
}